import { PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
var SentToIdentifyCommentPipe = /** @class */ (function () {
    function SentToIdentifyCommentPipe(translateService) {
        this.translateService = translateService;
    }
    SentToIdentifyCommentPipe.prototype.transform = function (commentType, corporateAccountName, isMyMessage, posted_by) {
        var commentTypesTranslations = {
            collaborator: "" + (isMyMessage ? 'COMMENT_TO_COLLABORATORS' : posted_by === 'company' ? 'COMMENT_TO_CORPORATE_BY_COLLABORATOR' : 'COMMENT_TO_COLLABORATORS'),
            company: "" + (isMyMessage ? 'COMMENT_TO_MANAGER' : 'COMMENT_TO_CORPORATE_BY_MANAGER'),
            corporate: 'COMMENT_TO_CORPORATE',
            internal: 'COMMENT_TO_INTERNAL',
            public: 'COMMENT_TO_PUBLIC',
        };
        var translatedCommentType = "MAINTENANCES.TABS.COMMENTS." + commentTypesTranslations[commentType];
        return this.translateService.instant(translatedCommentType, {
            corporateAccountName: corporateAccountName
        });
    };
    return SentToIdentifyCommentPipe;
}());
export { SentToIdentifyCommentPipe };
